export const LEARN_MORE_URL = 'https://yandex.ru/support2/rythm/ru/author/cpa';

export const CATALOG_URL = '/advertising/catalog';
